import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

const FILTER_PARAM = 'filter';

export type FilterType = 'all' | 'recent' | 'liked';

export const useSubscriptionFilter = () => {
  const [isMenuDropdownOpen, setIsMenuDropdownOpen] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const param = searchParams.get(FILTER_PARAM);
  const filter: FilterType = param === 'recent' || param === 'liked' ? param : 'all';

  const handleFilterSelect = (newFilter: FilterType) => {
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        if (newFilter === 'all') {
          next.delete(FILTER_PARAM);
        } else {
          next.set(FILTER_PARAM, newFilter);
        }
        return next;
      },
      { replace: true }
    );
    setIsMenuDropdownOpen(false);
  };

  return { filter, handleFilterSelect, isMenuDropdownOpen, setIsMenuDropdownOpen };
};
